/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CallbackMethod = zod.enum(['async_upload', 'url_upload', 'direct_upload']);

export type CallbackMethod = zod.input<typeof CallbackMethod>;
export type CallbackMethodOutput = zod.output<typeof CallbackMethod>;
